var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"children-view"},[(_vm.mouldId!=8&&_vm.mouldId)?_c('index-edit-show',{ref:"index",attrs:{"companyId":_vm.companyId,"createdTime":_vm.companyCreatedTime},on:{"setMould":_vm.setMould}}):_vm._e(),_vm._v(" "),(_vm.mouldId==8)?_c('new-mould',{attrs:{"data":_vm.data[0]}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a29b7e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexEditShow/indexEditShowBox.vue
// module id = null
// module chunks = 